export const messages = {
  configurePageTitle: 'Configure Promo Code Offer',
  updatePageTitle: 'Update Promo Code Offer',
  subtitle: 'Provide benefits when members enter a promo code',
  listPageTitle: 'Promo Code Offers',
  promocodeDetailsPageTitle: 'Promo Code Details',
  downloadLinkGenerationFailed: 'Failed to generate download link. Please try again.',
  downloadLinkGenerating: 'Generating download link...',
  downloadFile: 'Download file',
  downloadProcessedCodes: 'Download Processed Codes',
  downloading: 'Downloading...',
  downloadReady: 'Your download is ready. Click the button below to download the file.',
  downloadAutomaticFailed: 'Automatic download failed. Click the link below to download the file.',
  deleteIndividualPromoCodesRedeemedNote:
    'Note: some of the promo codes may have already been redeemed. These will not be deleted from the system if you proceed.',
  invalidCsvSingleColumn: 'The CSV must be one column only.',
  viewAllCodesTitle: 'View All Codes',
  viewAllCodesSearchPlaceholder: 'Search',
  viewAllCodesEmptyTitle: 'No promo codes yet',
  viewAllCodesEmptyDescription: 'Uploaded codes will appear here.',
  viewAllCodesNoResultsTitle: 'No codes found',
  viewAllCodesNoResultsDescription: 'Try a different search.',
  viewAllCodesErrorTitle: 'Unable to load codes',
  viewAllCodesErrorDescription: 'Please try again.',
};
